import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserModel } from '../models';
import { localStorageService, StorageKey } from '../services/local-storage.service';

export interface MerchantState {
  allowedMerchants: UserModel[];
  selectedMerchantId?: string;
  loaded: boolean;
}

const initialState: MerchantState = {
  allowedMerchants: [],
  selectedMerchantId: localStorageService.getItem(StorageKey.SELECTED_MERCHANT_ID) ?? undefined,
  loaded: false,
};

const merchantSlice = createSlice({
  name: 'merchant',
  initialState,
  reducers: {
    setAllowedMerchants: (state, action: PayloadAction<UserModel[]>) => {
      state.allowedMerchants = action.payload;
      state.loaded = true;
      if (!state.selectedMerchantId && action.payload.length > 0 && action.payload[0].id) {
        state.selectedMerchantId = action.payload[0].id;
        localStorageService.setItem(StorageKey.SELECTED_MERCHANT_ID, action.payload[0].id);
      }
      if (state.selectedMerchantId && !action.payload.some((m) => m.id === state.selectedMerchantId)) {
        state.selectedMerchantId = action.payload[0]?.id;
        if (state.selectedMerchantId) {
          localStorageService.setItem(StorageKey.SELECTED_MERCHANT_ID, state.selectedMerchantId);
        } else {
          localStorageService.removeItem(StorageKey.SELECTED_MERCHANT_ID);
        }
      }
    },
    setSelectedMerchantId: (state, action: PayloadAction<string>) => {
      state.selectedMerchantId = action.payload;
      localStorageService.setItem(StorageKey.SELECTED_MERCHANT_ID, action.payload);
    },
    clearMerchant: (state) => {
      state.allowedMerchants = [];
      state.selectedMerchantId = undefined;
      state.loaded = false;
      localStorageService.removeItem(StorageKey.SELECTED_MERCHANT_ID);
    },
  },
});

export const merchantReducer = merchantSlice.reducer;
export const merchantSliceActions = {
  setAllowedMerchants: merchantSlice.actions.setAllowedMerchants,
  setSelectedMerchantId: merchantSlice.actions.setSelectedMerchantId,
  clearMerchant: merchantSlice.actions.clearMerchant,
};
